/* eslint-disable react/sort-prop-types */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from '@reach/router';
import useConfigureApp from '../../hooks/useConfigureApp';

const TenantContext = React.createContext();
const useTenantContext = () => useContext(TenantContext);

const TenantProvider = ({ children, queryParams, currentSession }) => {
  const navigate = useNavigate();
  const [session, setSession] = useState(currentSession.session);
  const [tenant, setTenant] = useState(currentSession.tenant);
  const { updateSession } = useConfigureApp();

  const updateTenantState = (localTenant) => {
    setTenant(localTenant);
  };

  const onSignIn = (localSession, localTenant) => {
    setSession(localSession);
    updateTenantState(localTenant);
    updateSession({
      tenant: localTenant,
      session: localSession,
    });
    navigate('/home', { replace: true });
  };

  const handleOnboardingModalClose = (onboardingChecklist) => {
    const newTenant = {
      ...tenant,
      onboardingChecklist,
    };
    setTenant(newTenant);
  };

  const onLogOut = () => {
    updateSession({
      tenant: null,
      session: null,
    });
    setSession(null);
    setTenant(null);
    navigate('/auth/signin', { replace: true });
  };

  const tenantContextValues = {
    handleOnboardingModalClose,
    onSignIn,
    onLogOut,
    session,
    tenant,
    queryParams,
  };

  return (
    <TenantContext.Provider value={tenantContextValues}>
      {children}
    </TenantContext.Provider>
  );
};

TenantProvider.defaultProps = {
  currentSession: {
    tenant: null,
    session: null,
  },
};

TenantProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  queryParams: PropTypes.shape({
    shop: PropTypes.string.isRequired,
    hmac: PropTypes.string,
    locale: PropTypes.string,
    timestamp: PropTypes.string,
  }).isRequired,
  currentSession: PropTypes.shape({
    tenant: PropTypes.object,
    session: PropTypes.object,
  }),
};

export default TenantProvider;
export { TenantContext, useTenantContext };
